import { Box, Grid2, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { Center } from "@mantine/core";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { CentreDetailsPanel } from "./components/centre-detailsPanel";
import { CentreContactPanel } from "./components/centre-contactPanel";
import { CentreAppointmentsPanel } from "./components/centre-appointmentsPanel";
import { CentreFileUploadPanel } from "./components/centre-filePanel";
import { PettyCashIndex } from "./components/pettyCash-index";
import { FuelAllowanceIndex } from "./components/fuelAllowance-index";
import { FormIndex } from "../form/form-index";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { CentreFormPanel } from "./components/centre-formPanel";




export const CentreView = () => {

    const [value, setValue] = useState("1");
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    return (
        <>
            <Grid2 container spacing={1} p={2}>

                <Grid2 size={{ xs: 12, sm: 4, md: 3 }} mt={5}>
                    <CentreDetailsPanel />

                </Grid2>


                <Grid2 size={{ xs: 12, sm: 8, md: 9 }}>
                    <TabContext value={value}>
                        <Grid2 size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "left" }}>

                            <TabList onChange={handleChange} variant="fullWidth" sx={{

                                backgroundColor: "grey.100",
                                borderRadius: 1,
                                minHeight: 48,
                                "& .MuiTabs-indicator": {
                                    display: "none",
                                },
                                "& .MuiTab-root": {
                                    flex: 1,
                                    minHeight: "48px",
                                    fontWeight: 500,
                                    borderRadius: 1,
                                    "&.Mui-selected": {
                                        backgroundColor: "primary.main",
                                        color: "white",
                                    },
                                },
                            }}>

                                <Tab label="Contacts & Appointments" value="1" />
                                <Tab label="Forms" value="2" />
                                <Tab label="PettyCash" value="3" />
                                <Tab label="Files" value="4" />
                            </TabList>

                        </Grid2>
                        <TabPanel value="1" sx={{ p: 0, mt: 0.76 }} >
                            <Grid2 container spacing={1}>

                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <CentreContactPanel />

                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <CentreAppointmentsPanel />

                                </Grid2>
                            </Grid2>
                        </TabPanel>
                        <TabPanel value="2" sx={{ p: 0, mt: 0.76 }} >
                            <Grid2 container spacing={1}>
                                <Grid2 size={{ xs: 12, sm: 12 }}>
                                    <CentreFormPanel/>
                                </Grid2>
                            </Grid2>
                        </TabPanel>
                        <TabPanel value="3" sx={{ p: 0, mt: 0.76 }} >
                            <Grid2 container spacing={1}>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <PettyCashIndex />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 6 }}>
                                    <FuelAllowanceIndex />
                                </Grid2>
                            </Grid2>
                        </TabPanel>
                        <TabPanel value="4" sx={{ p: 0, mt: 0.76 }} >
                            <Grid2 container spacing={1}>
                                <Grid2 size={{ xs: 12, sm: 12 }}>
                                    <CentreFileUploadPanel />
                                </Grid2>
                            </Grid2>
                        </TabPanel>
                    </TabContext >
                </Grid2>
            </Grid2>
        </>
    );
};